import { useTranslation } from 'react-i18next';

import LoadingComponent from '@/components/common/loading/loading.component';
import { PSButton } from '@/components/ui/button';

type Props = {
  isLoading: boolean;
  isError: boolean;
  isSuccess: boolean;
  refetch: () => void;
  children: any;
};
export default function CustomContainer({ isLoading, isError, isSuccess, refetch, children, ...props }: Props) {
  const { t } = useTranslation();

  let content;

  if (isLoading) {
    content = (
      <div className="tw-px-8">
        <LoadingComponent />
      </div>
    );
  } else if (isError) {
    content = (
      <div className="tw-p-8 text-center">
        <p className="tw-text-red-500">{t('Wizard/general/key10')}</p>
        <PSButton id="btn-custom-refetch" variant="link" onClick={refetch} title={t('Wizard/general/key11')} />
      </div>
    );
  } else if (isSuccess) {
    content = children;
  } else {
    content = null;
  }

  return (
    <div className="tw-w-full" {...props}>
      {content}
    </div>
  );
}
